import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaeButton from "../common_widgets/button";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../common_widgets/popup";
import  {
  IMdaeDataGridColumnProps,
  IMdaeDataGridProps,
} from "../common_widgets/data-grid";
import {
  RESET_OCR_STATUS,
  SAVE_CASE_SEARCH_CRITERIA_DATAGRID_CHNAGES,
  ADD_SELECTED_IDS_TO_ADD_TO_AUDIT_LIST,
  TOGGLE_CASE_SEARCH_LIST_POPUP,
  caseSearchCriteriaDatagridKeyExpr,
  formatCaseSearchCriteriaList,
  REMOVE_SELECTED_IDS_TO_ADD_TO_AUDIT_LIST,
  addCommonProperties,
  updatedOn,
  createdOn,
  SET_FEEDBACK_SECTION_VALUES,
  SET_CASE_SEARCH_DOCUMENT_DATA,
  ocrDocumentData,
  sortOrder,
  CASE_SEARCH_CLICKED,
  DOS_SEARCH_TYPES,
  addSelectedCasesToAudit,
  SET_KEY_INFORMATION_CASE_SEARCH_DATA,
  DOS_SEARCH_TYPE_DETAILS,
  SET_SEARCH_BY,
} from "./reducers/case-search-reducer";
import { chain, first, isEqual } from "lodash";
import "./index.scss";
import { Button, DataGrid } from "devextreme-react";
import {
  Column,
  CustomRule,
  Editing,
  Item,
  MasterDetail,
  Scrolling,
  Selection,
  Toolbar,
} from "devextreme-react/data-grid";
import {
  CASE_SEARCH_WARNING_MESSAGES,
  CLAIM_TYPES,
  getCaseSearchCriteriaMappings,
  SEARCH_BY,
  searchByListForHB,
  searchByListForPB,
  TEMPLATE_TYPES,
} from "./constants";
import {
  getHeaderColumnWithNote,
  resetAutocompleteData,
  resetCaseFoundList,
  searchCasesForKeyInformation,
  totalIdentifierMatchedCountColumnName,
  totalIdentifierMatchedWeightColumnName,
} from "./case-search-common-functions";
import $ from "jquery";
import MdaeDateAutoComplete from "../common_widgets/autocomplete-date";
import MdaeAutoComplete from "../common_widgets/autocomplete";
import DataSource from "devextreme/data/data_source";
import ArrayStore from "devextreme/data/array_store";
import { toggleCaseDetailPopup } from "../../pages/external-audit/case-detail/case-detail-common-functions";
import {
  HIDE_LOADER,
  SHOW_LOADER,
  TOGGLE_CONFIRMATION_POPUP,
} from "../mdae-common-reducer";
import { downloadExcelForDataGrid } from "../../utils/excelUtils";
import OcrUserFeedbackPopup from "./ocr-user-feedback-popup";
import MdaeFeedbackWidget from "../common_widgets/user-feedback-widget";
import { actions,callOperation } from "async-ops";
import { SAVE_OCR_FEEDBACK } from './services/save-ocr-feedback';
import dxDataGrid from "devextreme/ui/data_grid";
import MdaeAddButton from "../common_widgets/add-button";
import { toggleAddCaseToRoundPopupVisible } from "./case-search-common-functions";
import { SET_ADD_CASE_TO_ROUND_DATA } from "../../pages/external-audit/reducers/external-audit-reducer";
import { getFormatedDate } from "../user-task-card-view/user-task-utils";
import MdaeDateBox from "../common_widgets/date-box";
import { SET_AUDIT_PROPERTIES_DATA } from "../../pages/external-audit/reducers/audit-properties-reducer";
import { convertDateFormat } from "../../utils/dateUtils";
import { SET_CASE_SEARCH_HEADER_DATA } from "../../pages/case-search/reducer/case-search-page-reducer";
import { CASE_DETAIL_POPUP_MODES } from "../../pages/external-audit/case-detail/component";
import { RadioSelectionCellComponent } from "./case-search-list";
import { SET_CASE_FORM_DATA } from "../../pages/external-audit/case-detail/case-data/reducers/case-data-reducer";
import { GET_AUDIT_PERIOD } from "../../pages/external-audit/services/get-audit-period";
import MdaeSelectBox from "../common_widgets/select-box";
import mdaeNotify, { NOTIFY_MESSAGE_TYPE } from "../common_widgets/toast/notify";
import MdaeRadioGroup from "../common_widgets/radio-group";
export const START_OCR_STATUS_POOLING = "START_OCR_STATUS_POOLING";
export const CASE_SEARCH_DATAGRID_SELECTION_MODES = {
  NONE: "none",
  MULTIPLE: "multiple",
};
export const CASE_SEARCH_CRITERIA_POPUP_MODE = {
  OCR_VALIDATION: "OCR_VALIDATION",
  CASE_SEARCH: "CASE_SEARCH",
  SINGLE_CASE_SEARCH: "SINGLE_CASE_SEARCH",
};
export const CASE_SEARCH_CRITERIA_POPUP_LOCATIONS = {
  CASE_SEARCH_PAGE: "CASE_SEARCH_PAGE",
  AUDIT: "AUDIT",
}

export const checkIsClaimIdSearchAppplicble = (eaAuditType) => {
  return ["POST-PAY", "DENIAL"].includes(eaAuditType);
}

export const changeCaseSearchCriteriaPopupMode = (dispatch, caseSearchCriteriaPopupMode) =>{
  dispatch({
    type: TOGGLE_CASE_SEARCH_LIST_POPUP,
    data: {
      caseSearchCriteriaPopupMode,

    },
  });
}
export const setCaseSearchClickInd = (dispatch, caseSearchClickedInd) =>{
  dispatch({
    type: CASE_SEARCH_CLICKED,
    data: {
      caseSearchClickedInd
        },
  });
}
export const toggleCaseSearchCriteriaListPopupVisible = (
  dispatch,
  isVisible,
  caseSearchCriteriaList = null,
  caseSearchCriteriaPopupMode = CASE_SEARCH_CRITERIA_POPUP_MODE.CASE_SEARCH,
  shouldResetCaseFoundList = true,
  isCaseSearchInitiated = false,
) => {
  dispatch({
    type: TOGGLE_CASE_SEARCH_LIST_POPUP,
    data: {
      caseSearchListPopupVisibleInd: isVisible,
      caseSearchCriteriaPopupMode,
    },
  });
  if (isVisible && shouldResetCaseFoundList) resetCaseFoundList(dispatch);
  if (isVisible) setCaseSearchClickInd(dispatch, isCaseSearchInitiated);
  if (
    isVisible &&
    caseSearchCriteriaPopupMode === CASE_SEARCH_CRITERIA_POPUP_MODE.CASE_SEARCH
  ) {
    resetAutocompleteData(dispatch);
    dispatch({
      type: SET_CASE_SEARCH_DOCUMENT_DATA,
      data: {
        ocrDocumentData: {
          ...ocrDocumentData,
        },
      },
    });
  }
  dispatch({
    type: RESET_OCR_STATUS,
  });
  if (caseSearchCriteriaList) {
    dispatch({
      type: TOGGLE_CASE_SEARCH_LIST_POPUP,
      data: {
        caseSearchCriteriaList,
      },
    });
  }
};
interface IFeedbackSectionOptions {
  thumbsUpClassName?: string;
  thumbsDownClassName?: string;
  feedbackText?: string;
  isFeedbackSectionVisible?: boolean;
  thumbsUpDisabled?: boolean;
  thumbsDownDisabled?: boolean;
}
export const feedbackSectionOptions : IFeedbackSectionOptions= {
  thumbsUpClassName: "agree-empty",
  thumbsDownClassName: "disagree-empty",
  feedbackText: "How did we do ?",
  isFeedbackSectionVisible: true,
  thumbsUpDisabled: false,
  thumbsDownDisabled: false
}
export const setOCRFeedbackSectionValues = (
  options: IFeedbackSectionOptions,
  dispatch:any
): void => {
  dispatch({
    type: SET_FEEDBACK_SECTION_VALUES,
    data: {feedbackSectionValues: { ...options } },
  });
};

const validationColumnName = "validationColumn";
const createdOnColumn = "createdOnColumn";
const sortOrderColumn = "sortOrderColumn";
const caseCountColumn ="caseCountColumn"
const caseFoundListDependantColumnNames = [
  validationColumnName,
  createdOnColumn,
  sortOrderColumn,
  caseCountColumn,
];
interface ICaseSearchCriteriaListPopup {
  location?: string;
  showClaimTypeSelector?: boolean;
}
const CaseSearchCriteriaListPopup: React.FC<ICaseSearchCriteriaListPopup> = (props) => {
  const dispatch = useDispatch();
  const caseSearchListDataGridRef = useRef(null);
  const getCaseSearchListDataGridInstance = (): dxDataGrid =>
    caseSearchListDataGridRef?.current?.instance;
  const [datagridSelectionMode, setDatagridSelectionMode] = useState(
    CASE_SEARCH_DATAGRID_SELECTION_MODES.NONE
  );
  const isOcrUserFeedbackPopupVisible = useSelector(
    (state) => state["caseSearchReducer"].isOcrUserFeedbackPopupVisible,
    isEqual
  );
  const caseSearchCriteriaList = useSelector(
    (state) => state["caseSearchReducer"].caseSearchCriteriaList,
    isEqual
  );
  const autocompleteData = useSelector(
    (state) => state["caseSearchReducer"].autocompleteData,
    isEqual
  );
  const caseSearchListPopupVisibleInd = useSelector(
    (state) => state["caseSearchReducer"].caseSearchListPopupVisibleInd,
    isEqual
  );
  const caseSearchCriteriaPopupMode = useSelector(
    (state) => state["caseSearchReducer"].caseSearchCriteriaPopupMode,
    isEqual
  );
  const keyInformationCaseSearchData = useSelector(
    (state) => state["caseSearchReducer"].keyInformationCaseSearchData,
    isEqual
  );
  const dosSearchType = useSelector(
    (state) => state["caseSearchReducer"].keyInformationCaseSearchData.dosSearchType,
    isEqual
  );
  const templateType = useSelector(
    (state) => state["caseSearchReducer"].keyInformationCaseSearchData.templateType
  );
  const auditPropertiesData = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData,
    isEqual
  );
  const eaCaseListData = useSelector(
    (state) => state["caseListReducer"].eaCaseListData,
    isEqual
  );
  const feedbackSectionValues = useSelector(
    (state) => state["caseSearchReducer"].feedbackSectionValues,
    isEqual
  );
  const s3ObjectName = useSelector(
    (state) => state["caseSearchReducer"].ocrPollingData?.s3ObjectName,
    isEqual
  );
  const ocrDocumentData = useSelector(
    (state: any) => state.caseSearchReducer.ocrDocumentData
  );
  const caseSearchClickedInd = useSelector(
    (state) => state["caseSearchReducer"].caseSearchClickedInd,
    isEqual
  );
  const selectedSearchBy = useSelector(
    (state) => state["caseSearchReducer"].selectedSearchBy,
    isEqual
  );
  const caseFoundListidentifier = useSelector(
    (state) =>
      state["caseSearchReducer"].caseFoundList?.reduce(
        (allCaseDetails, current) =>
          (allCaseDetails +=
            current?.caseDetailId + current[caseSearchCriteriaDatagridKeyExpr]),
        "" //this is initial value
      )
  );
  const caseSearchCriteriaIdentifier = useSelector(
    (state) =>
      Math.max(
        ...state["caseSearchReducer"].caseSearchCriteriaList?.map((x) =>
          (new Date(x[updatedOn]) as Date)?.getTime()
        )
      ),
    isEqual
  );
  const caseFoundList: any[] = useSelector(
    (state) => state["caseSearchReducer"].caseFoundList,
    isEqual
  );
  const externalAuditSelectedIndex = useSelector(
    (state) => state["externalAuditReducer"].externalAuditSelectedIndex,
    isEqual
  );
  const selectedCaseDetailIdsToAddToAudit: number[] = useSelector(
    (state) => state["caseSearchReducer"].selectedCaseDetailIdsToAddToAudit
  );
  const auditnotificationDate = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData.notificationDate ? state["auditPropertiesReducer"].auditPropertiesData.notificationDate:getFormatedDate(new Date()),
    isEqual
  )
  const claimTypes = useSelector(
    (state) => state["auditPropertiesReducer"].claimTypes
  );
  const claimTypeCd = useSelector(
    (state) => state["caseSearchPageReducer"].claimTypeCd
  );
  const isClaimIdSearchAppplicble = useSelector((state) =>
    state["auditPropertiesReducer"].auditPropertiesData.eaAuditType
      ? checkIsClaimIdSearchAppplicble(
          state["auditPropertiesReducer"].auditPropertiesData.eaAuditType
        )
      : true
  );
  const serviceTo = useSelector(
    (state) => state["caseSearchPageReducer"].serviceTo
  );
  const serviceFrom = useSelector(
    (state) => state["caseSearchPageReducer"].serviceFrom
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );

  const emdrPayerClaimId = useSelector(
    (state) => state["caseSearchPageReducer"]?.emdrPayerClaimId
  );

  const originalServiceDatesRef = useRef(null);

  const onClaimTypeChanged = useCallback((e) => {
    dispatch({
      type: SET_KEY_INFORMATION_CASE_SEARCH_DATA,
      data: {
        keyInformationCaseSearchData: {
          claimTypeCd: e?.value || null,
        },
      },
    });
    resetCaseFoundList(dispatch);
  }, [dispatch]);

  useEffect(() => {
    chain(caseFoundList)
      .groupBy(x => x[caseSearchCriteriaDatagridKeyExpr])
      .forEach((group) => {
        if (group.length === 1) {
          dispatch({
            type: ADD_SELECTED_IDS_TO_ADD_TO_AUDIT_LIST,
            data: [first(group)?.caseDetailId],
          });
        }
      })
      .value();
  }, [caseFoundListidentifier]);


  useEffect(() => {
    if (dosSearchType !== DOS_SEARCH_TYPES.SINGLE_DOS) return;
    if (!Array.isArray(caseSearchCriteriaList)) return;

    const parseDate = (value) => {
      if (!value) return null;
      const d = new Date(value);
      return isNaN(d.getTime()) ? null : d;
    };

    const admitDates = [];
    const dischargeDates = [];

    caseSearchCriteriaList.forEach((row) => {
      const admit = parseDate(
        row.inpatientAdmitDate || row.caseServiceFromDate
      );
      const discharge = parseDate(
        row.inpatientDischargeDate || row.caseServiceThroughDate
      );

      if (admit) admitDates.push(admit);
      if (discharge) dischargeDates.push(discharge);
    });

    const hasAdmit = admitDates.length > 0;
    const hasDischarge = dischargeDates.length > 0;

    if (
      !originalServiceDatesRef.current &&
      auditPropertiesData?.serviceFromDate
    ) {
      originalServiceDatesRef.current = {
        serviceFromDate: auditPropertiesData.serviceFromDate,
        serviceToDate: auditPropertiesData.serviceToDate,
      };
    }

    if (!hasAdmit && !hasDischarge) {
      if (originalServiceDatesRef.current) {
        dispatch({
          type: SET_AUDIT_PROPERTIES_DATA,
          data: {
            auditPropertiesData: {
              ...auditPropertiesData,
              serviceFromDate: originalServiceDatesRef.current.serviceFromDate,
              serviceToDate: originalServiceDatesRef.current.serviceToDate,
            },
          },
        });
        originalServiceDatesRef.current = null;
      }
      return;
    }

    let nextSearchBy = null;
    if (hasDischarge) {
      nextSearchBy = "discharge_date";
    } else if (hasAdmit) {
      nextSearchBy = "admit_date";
    }

    if (nextSearchBy && selectedSearchBy !== nextSearchBy) {
      dispatch({
        type: SET_SEARCH_BY,
        data: { selectedSearchBy: nextSearchBy },
      });
    }

    const originalFrom = originalServiceDatesRef.current?.serviceFromDate
      ? new Date(originalServiceDatesRef.current.serviceFromDate)
      : null;

    const originalTo = originalServiceDatesRef.current?.serviceToDate
      ? new Date(originalServiceDatesRef.current.serviceToDate)
      : null;

    if (originalFrom) admitDates.push(originalFrom);
    if (originalTo) dischargeDates.push(originalTo);

    const minAdmit = hasAdmit ? new Date(Math.min(...admitDates)) : null;
    const maxDischarge = hasDischarge
      ? new Date(Math.max(...dischargeDates))
      : null;
    const updatedData = {};

    if (!hasAdmit && originalServiceDatesRef.current?.serviceFromDate) {
      updatedData["serviceFromDate"] =
        originalServiceDatesRef.current.serviceFromDate;
    } else if (minAdmit) {
      updatedData["serviceFromDate"] = convertDateFormat(
        minAdmit,
        "MM/DD/YYYY"
      );
    }

    if (!hasDischarge && originalServiceDatesRef.current?.serviceToDate) {
      updatedData["serviceToDate"] =
        originalServiceDatesRef.current.serviceToDate;
    } else if (maxDischarge) {
      updatedData["serviceToDate"] = convertDateFormat(
        maxDischarge,
        "MM/DD/YYYY"
      );
    }

    if (Object.keys(updatedData).length > 0) {
      dispatch({
        type: SET_AUDIT_PROPERTIES_DATA,
        data: {
          auditPropertiesData: {
            ...auditPropertiesData,
            ...updatedData,
          },
        },
      });
    }
  }, [caseSearchCriteriaList]);

  const getDataGridSelectedRowKeys = useCallback(() => {
    return getCaseSearchListDataGridInstance().getSelectedRowKeys();
  }, []);

  const bulkDeleteSelectedRows = useCallback(() => {
    const caseSearchListDataGridInstance = getCaseSearchListDataGridInstance();
    if (datagridSelectionMode === CASE_SEARCH_DATAGRID_SELECTION_MODES.NONE) {
      setDatagridSelectionMode(CASE_SEARCH_DATAGRID_SELECTION_MODES.MULTIPLE);
    } else {
      setDatagridSelectionMode(CASE_SEARCH_DATAGRID_SELECTION_MODES.NONE);

      getDataGridSelectedRowKeys().forEach((key) => {
        let rowIndex = caseSearchListDataGridInstance.getRowIndexByKey(key);
        caseSearchListDataGridInstance.deleteRow(rowIndex);
        caseSearchListDataGridInstance.refresh();
      });

      setTimeout(() =>{
        caseSearchListDataGridInstance.refresh();
      }, 500)
    }
  }, [datagridSelectionMode]);

  const onCaseSearchCriteriaDatagridRowInserted = useCallback((e) => {
    e.component.clearSorting();
    e.component.columnOption(createdOn, "sortOrder", "desc");
    e.component.columnOption(sortOrder, "sortOrder", "asc");
  }, []);

  const onCaseSearchCriteriaDatagridSaving = useCallback((e: any) => {
    if (e.changes?.length > 0 && first<any>(e.changes)?.type === "insert") {
      e.changes.forEach((item) => {
        addCommonProperties(item.data, null);
      });
    } else if (
      e.changes?.length > 0 &&
      first<any>(e.changes)?.type === "update"
    ) {
      e.changes.forEach((item) => {
        item.data[updatedOn] = new Date();
      });
    }
    dispatch({
      type: SAVE_CASE_SEARCH_CRITERIA_DATAGRID_CHNAGES,
      data: {
        change: e.changes[0],
      },
    });
  }, []);

  const onMasterRowCollapsedOrExpanded = useCallback(
    (e) => {
      e.component.repaintRows(e.component.getRowIndexByKey(e.key));
    },
    [caseFoundListidentifier]
  );

  const onCaseSearchCriteriaDatagridCellPrepared = useCallback(
    (e) => {
      //below code hides expand icon for rows that did not match any cases
      if (e.column.type === "detailExpand" && e.rowType === "data") {
        if (
          !caseFoundList.some(
            (x) => x[caseSearchCriteriaDatagridKeyExpr] === e.key
          )
        ) {
          e.cellElement.style.visibility = "hidden";
        }
      }
    },
    [caseFoundListidentifier]
  );

  const resetDataGridSelection = useCallback(() => {
    const caseSearchListDataGridInstance = getCaseSearchListDataGridInstance();
    setTimeout(() => {
      caseSearchListDataGridInstance.selectRowsByIndexes([1]).then(() => {
        caseSearchListDataGridInstance.deselectAll();
      });
    }, 500);
  }, []);

  const onCaseSearchListPopupShowing = useCallback(() => {
    // Following code is a hacky way to make datagrid selection work properly
    //please re-check if selection works properly in future devexpress release
    //and remove this code
    setTimeout(() => {
      getCaseSearchListDataGridInstance()
        .refresh()
        .then(() => {
          resetDataGridSelection();
        });
    }, 100);
      setOCRFeedbackSectionValues(
        {...feedbackSectionOptions},
        dispatch
      );
  }, []);

  const getSelectedCasedToAddToAudit = useCallback(() => {
    return caseFoundList?.filter((x) =>
      selectedCaseDetailIdsToAddToAudit.includes(x.caseDetailId)
    );
  }, [caseFoundListidentifier, selectedCaseDetailIdsToAddToAudit, caseFoundList]);

  const onAddSelectedCasesToAuditBtnClick = useCallback(() => {
    if (
      props.location === CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE
    ) {
      toggleCaseSearchCriteriaListPopupVisible(dispatch, false);
      dispatch(actions.asyncOperationStart(GET_AUDIT_PERIOD, {}));
      setTimeout(() => {
        dispatch({
          type: SET_CASE_FORM_DATA,
          data: {
            caseData: {
              claimTypeCd: claimTypeCd,
              processManagerId: currentUser.userId,
            },
          },
        });
        dispatch({
          type: SET_AUDIT_PROPERTIES_DATA,
          data: {
            auditPropertiesData: {
              startDate: new Date(),
            },
          },
        });
      }, 2000);
      //reset case detail popup data
      toggleCaseDetailPopup(
        dispatch,
        true,
        "Add Case",
        {},
        0
      );
      //open case detail popup with data
      setTimeout(() => {
        const selectedCaseData = first(getSelectedCasedToAddToAudit());
        const payerClaimIdToUse = selectedCaseData?.payerCaseId || emdrPayerClaimId || "";
        toggleCaseDetailPopup(
          dispatch,
          true,
          "Add Case",
          {
            ...selectedCaseData,
            mode: CASE_DETAIL_POPUP_MODES.CREATE,
            claimType: claimTypes?.find((x) => x.code === claimTypeCd)
              ?.description,
            payerCaseId: payerClaimIdToUse,
          },
          0
        );
        if (payerClaimIdToUse) {
          setTimeout(() => {
            dispatch({
              type: SET_CASE_FORM_DATA,
              data: {
                caseData: {
                  payerCaseId: payerClaimIdToUse,
                },
              },
            });
          }, 150);
        }
      }, 100);
    } else {
      if (eaCaseListData[0]?.caseList.length > 0) {
        toggleAddCaseToRoundPopupVisible(dispatch, true);
        dispatch({
          type: SET_ADD_CASE_TO_ROUND_DATA,
          data: {
            roundStartDate: auditnotificationDate,
            addCaseToRoundNumber: 1,
            popUpCalledFrom: "keyinfosearchcase",
          },
        });
      } else {
        dispatch({
          type: SET_ADD_CASE_TO_ROUND_DATA,
          data: {
            roundStartDate: auditnotificationDate,
            addCaseToRoundNumber: 1,
          },
        });
        dispatch(
          addSelectedCasesToAudit(
            getSelectedCasedToAddToAudit(),
            caseSearchCriteriaList
          )
        );
      }
    }
  }, [
    caseFoundListidentifier,
    selectedCaseDetailIdsToAddToAudit,
    caseSearchCriteriaIdentifier,
    claimTypes,
    claimTypeCd,
    getSelectedCasedToAddToAudit,
    auditnotificationDate,
    caseSearchCriteriaList,
    caseFoundList,
    emdrPayerClaimId
  ]);

  useEffect(() => {
    const caseSearchListDataGridInstance = getCaseSearchListDataGridInstance();
    if (caseSearchListDataGridInstance) {
      caseSearchListDataGridInstance?.collapseAll(-1);
      if (caseFoundList?.length > 0) {
        caseFoundList.forEach((foundCase) => {
          if (
            !caseSearchListDataGridInstance.isRowExpanded(
              foundCase[caseSearchCriteriaDatagridKeyExpr]
            )
          )
            caseSearchListDataGridInstance.expandRow(
              foundCase[caseSearchCriteriaDatagridKeyExpr]
            );
        });
      }
    }
  }, [caseFoundListidentifier]);

  const caseSearchListDataGridOptions = useMemo(() => {
    return getCaseSearchCriteraListDataGridOptions(
      keyInformationCaseSearchData.claimTypeCd,
      ocrDocumentData.documentName
        ? ocrDocumentData.documentName
        : "Case Search Critieria",
      templateType,
      dosSearchType
    );
  }, [
    keyInformationCaseSearchData.claimTypeCd,
    ocrDocumentData.documentName,
    caseSearchClickedInd,
    templateType,
    caseFoundList,
    dosSearchType
  ]);

  const downloadSearchCriteriaExcel = useCallback(() => {
    dispatch({ type: SHOW_LOADER });
    downloadExcelForDataGrid(
      getCaseSearchListDataGridInstance(),
      ocrDocumentData.documentName ? ocrDocumentData.documentName: "Case Search Critieria"
    )
      .then(() => {
        dispatch({
          type: TOGGLE_CONFIRMATION_POPUP,
          data: {
            visible: false,
          },
        });
        toggleCaseSearchCriteriaListPopupVisible(dispatch, false);
        setTimeout(function() {
          dispatch({ type: HIDE_LOADER });
        }, 1000);
      })
      .catch((ex) => {
        console.log(ex);
      });
  }, [ocrDocumentData.documentName]);

  const onCaseSearchListPopupClose = useCallback(() => {
    if (
      caseSearchCriteriaList.length &&
      caseSearchCriteriaPopupMode == CASE_SEARCH_CRITERIA_POPUP_MODE.CASE_SEARCH
    ) {
      dispatch({
        type: TOGGLE_CONFIRMATION_POPUP,
        data: {
          visible: true,
          cancelShown: true,
          cancelLabel: "Cancel",
          confirmShown: true,
          confirmLabel: "Yes",
          declineShown: true,
          declineLabel: "No",
          width: 380,
          height: 200,
          contentHtml:
            "Leaving will cause any remaining case search criteria to be lost. Would you like to download your current case search criteria?",
          onConfirm: downloadSearchCriteriaExcel,
          onCancel: () => {
            dispatch({
              type: TOGGLE_CONFIRMATION_POPUP,
              data: {
                visible: false,
              },
            });
          },
          onDecline: () => {
            dispatch({
              type: TOGGLE_CONFIRMATION_POPUP,
              data: {
                visible: false,
              },
            });
            toggleCaseSearchCriteriaListPopupVisible(dispatch, false);
          },
        },
      });
    } else {
      toggleCaseSearchCriteriaListPopupVisible(dispatch, false);
    }
  }, [caseSearchCriteriaIdentifier, caseSearchCriteriaPopupMode]);
  const getCaseListPopupTitle = useCallback(() => {
    return (
      <MdaePopupTitle closePopupHandler={onCaseSearchListPopupClose}>
        {caseSearchCriteriaPopupMode ===
        CASE_SEARCH_CRITERIA_POPUP_MODE.OCR_VALIDATION
          ? "Scan Validation"
          : "Case Search"}
        {" - "}
        {DOS_SEARCH_TYPE_DETAILS.find(
          (x) => x.value === keyInformationCaseSearchData.dosSearchType
        )?.displayAlias ?? ""}
      </MdaePopupTitle>
    );
  }, [
    caseFoundListidentifier,
    caseSearchCriteriaIdentifier,
    caseSearchCriteriaPopupMode,
  ]);

  const onThumbsUp = () => {
    const data = {
      fileName: s3ObjectName,
      feedbackFlag: true,
      documentId: ocrDocumentData.documentId
    };

    callOperation(SAVE_OCR_FEEDBACK, data);

    setOCRFeedbackSectionValues(
      {
        ...feedbackSectionOptions,
        thumbsUpClassName: "agree-filled",
        thumbsDownClassName: "disagree-empty",
        feedbackText: "Thank you for your feedback!",
        thumbsUpDisabled: true,
        thumbsDownDisabled: false,
      },
      dispatch
    );
  };
  const onThumbsDown = () => {
    const data = {
      fileName: s3ObjectName,
      feedbackFlag: false,
      documentId: ocrDocumentData.documentId
    };
    callOperation(SAVE_OCR_FEEDBACK, data);

    setOCRFeedbackSectionValues(
      {
        ...feedbackSectionOptions,
        thumbsUpClassName: "agree-empty",
        thumbsDownClassName: "disagree-filled",
        feedbackText: "Thank you for your feedback!",
        thumbsUpDisabled: false,
        thumbsDownDisabled: true,
      },
      dispatch
    );
  };

  const {
    columns: columnConfigurations,
    ...restConfigurations
  } = caseSearchListDataGridOptions;

  const caseSearchCriteriaFooterComponent = useMemo(() => {
    const onSearchCasesClick = (params) => {
      const selectedClaimTypeCd =
        keyInformationCaseSearchData.claimTypeCd?.toUpperCase();
      if (
        selectedClaimTypeCd !== CLAIM_TYPES.HOSPITAL &&
        selectedClaimTypeCd !== CLAIM_TYPES.PROFESSIONAL
      ) {
        mdaeNotify({
          message: "Please select Claim Type (Professional or Hospital) before searching.",
          messageType: NOTIFY_MESSAGE_TYPE.WARNING,
        });
        return;
      }
      changeCaseSearchCriteriaPopupMode(dispatch, CASE_SEARCH_CRITERIA_POPUP_MODE.CASE_SEARCH);
      setCaseSearchClickInd(dispatch,true);
      resetCaseFoundList(dispatch);
      const caseSearchCriteriadatagridInstance = getCaseSearchListDataGridInstance();
      let saveChangesPromise = Promise.resolve();
      if(caseSearchCriteriadatagridInstance.hasEditData()){
        saveChangesPromise = caseSearchCriteriadatagridInstance.saveEditData();
      }
      saveChangesPromise.then(() => {
        const keyInformationCaseSearchList = caseSearchCriteriaList.filter(
          (x) => {

            const { isValidRow } = validateCaseSearchRow(
              x,
              keyInformationCaseSearchData.claimTypeCd,
              keyInformationCaseSearchData.dosSearchType,
              auditPropertiesData.eaAuditType,
              templateType,
              selectedSearchBy
            );
            return isValidRow;
          }
        );
        searchCasesForKeyInformation(
          dispatch,
          params,
          formatCaseSearchCriteriaList(keyInformationCaseSearchList),
          keyInformationCaseSearchData.claimTypeCd,
          props.location ===
            CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE
            ? undefined
            : keyInformationCaseSearchData.dosSearchType,
          props.location ===
            CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE
            ? {
                ...auditPropertiesData,
                serviceFromDate: serviceFrom,
                serviceToDate: serviceTo,
              }
            : auditPropertiesData,
          eaCaseListData,
          null,
          templateType,
          selectedSearchBy ===SEARCH_BY.ADMIT
        ).then(() =>{
          caseSearchCriteriadatagridInstance?.repaint();
        });
      });
    };
    return (
      <MdaePopupFooter>
        <MdaePopupFooterStartButtons>
          <MdaeButton
            id={"pnlCancelCaseSearchListSecondaryBtn"}
            role={"secondary"}
            onClick={onCaseSearchListPopupClose}
          >
            Cancel
          </MdaeButton>
        </MdaePopupFooterStartButtons>
        <MdaePopupFooterEndButtons>
        <MdaeFeedbackWidget
                id="ocrFeedbackSection"
                thumbsUpClassName={`thumbs-up ${feedbackSectionValues?.thumbsUpClassName}`}
                thumbsDownClassName={`thumbs-down ${feedbackSectionValues?.thumbsDownClassName}`}
                onThumbsUpClick={onThumbsUp}
                onThumbsDownClick={onThumbsDown}
                isMdaeFeedbackWidgetVisible={
                  caseSearchCriteriaPopupMode ===
                  CASE_SEARCH_CRITERIA_POPUP_MODE.OCR_VALIDATION
                }
                thumbsUpDisabled={feedbackSectionValues?.thumbsUpDisabled}
                thumbsDownDisabled={feedbackSectionValues?.thumbsDownDisabled}
                feedbackSectionClassName={"ocr-feedback-section"}
                feedbackText={feedbackSectionValues?.feedbackText}
              />
          <MdaeButton
            id={"pnlKeyInfoCaseSearchBtn"}
            role={"primary"}
            validationGroup={"keyInfoCaseSearchValidationGroup"}
            onClick={onSearchCasesClick}
          >
            Search Cases
          </MdaeButton>
          <MdaeButton
            id={"pnlAddSelectedCasesToAuditPrimaryBtn"}
            role={"primary"}
            visible={caseFoundList?.length > 0}
            onClick={onAddSelectedCasesToAuditBtnClick}
            disabled={selectedCaseDetailIdsToAddToAudit?.length === 0}
          >
            {`Add (${selectedCaseDetailIdsToAddToAudit?.length}) Selected Cases`}
          </MdaeButton>
        </MdaePopupFooterEndButtons>
      </MdaePopupFooter>
    );
  }, [
    caseFoundListidentifier,
    keyInformationCaseSearchData.claimTypeCd,
    auditPropertiesData.eaAuditType,
    keyInformationCaseSearchData.dosSearchType,
    auditPropertiesData.serviceFromDate,
    auditPropertiesData.serviceToDate,
    caseSearchCriteriaIdentifier,
    JSON.stringify(selectedCaseDetailIdsToAddToAudit),
    feedbackSectionValues,
    caseSearchCriteriaPopupMode,
    selectedSearchBy
  ]);

  const caseFoundListDependantColumns = useMemo(
    () =>
      getCaseSearchCriteriaStartColumns(
        keyInformationCaseSearchData,
        caseFoundList,
        caseSearchClickedInd,
        auditPropertiesData.eaAuditType,
        templateType,
        selectedSearchBy
      ).map((columnsProps: IMdaeDataGridColumnProps, index) => {
        return (
          <Column
            {...columnsProps}
            key={`caseSearchListDatagridColumn${columnsProps.dataField ||
              columnsProps.name}`}
          />
        );
      }),
    [
      auditPropertiesData.eaAuditType,
      keyInformationCaseSearchData.claimTypeCd,
      keyInformationCaseSearchData.dosSearchType,
      caseFoundListidentifier,
      caseSearchClickedInd,
      templateType,
      selectedSearchBy
    ]
  );
  const caseSearchCriteraColumns = useMemo(
    () =>
      columnConfigurations
        .filter(
          (columnsProps: IMdaeDataGridColumnProps) =>
            !caseFoundListDependantColumnNames.includes(columnsProps.name)
        )
        .map((columnsProps: IMdaeDataGridColumnProps) => {
          return (
            <Column
              {...columnsProps}
              key={`caseSearchListDatagridColumn${columnsProps.dataField ||
                columnsProps.name}`}
              editCellRender={(e) => {
                switch (columnsProps.dataType) {
                  case "date":
                    return (
                      <MdaeDateAutoComplete
                        id={`dtAutocomplete${columnsProps.dataField}`}
                        dataSource={autocompleteData}
                        value={e.value}
                        onValueChanged={(ex) => {
                          e.setValue(ex.value);
                        }}
                      />
                    );
                  default:
                    return (
                      <MdaeAutoComplete
                        id={`txtAutocomplete${columnsProps.dataField}`}
                        dataSource={autocompleteData}
                        defaultValue={e.value}
                        onValueChanged={(ex) => {
                          e.setValue(ex.value);
                        }}
                      />
                    );
                }
              }}
            >
              <CustomRule
                message={"Invalid date"}
                ignoreEmptyValue
                validationCallback={(e) => {
                  switch (columnsProps.dataType) {
                    case "date":
                      return (new Date(e.value) as any) != "Invalid Date";
                    default:
                      return true;
                  }
                }}
              />
            </Column>
          );
        }),
    [keyInformationCaseSearchData.claimTypeCd, autocompleteData?.length,caseSearchClickedInd]
  );
  const changeServiceFromDate = useCallback((e) => {
    if (
      props.location ==
      CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE
    ) {
      dispatch({
        type: SET_CASE_SEARCH_HEADER_DATA,
        data: {
          serviceFrom: convertDateFormat(e.value, "MM/DD/YYYY"),
        },
      });
    } else {
      dispatch({
        type: SET_AUDIT_PROPERTIES_DATA,
        data: {
          auditPropertiesData: {
            serviceFromDate: convertDateFormat(e.value, "MM/DD/YYYY"),
          },
        },
      });
    }
  }, [props.location]);
  const changeServiceToDate = useCallback((e) => {
    if (
      props.location ==
      CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE
    ) {
      dispatch({
        type: SET_CASE_SEARCH_HEADER_DATA,
        data: {
          serviceTo: convertDateFormat(e.value, "MM/DD/YYYY"),
        },
      });
    }
    {
      dispatch({
        type: SET_AUDIT_PROPERTIES_DATA,
        data: {
          auditPropertiesData: {
            serviceToDate: convertDateFormat(e.value, "MM/DD/YYYY"),
          },
        },
      });
    }
  }, [props.location]);
  return (
    <>
      <MdaePopup
        height={"95%"}
        width={"98%"}
        mdaeTitleRender={getCaseListPopupTitle}
        visible={caseSearchListPopupVisibleInd}
        onShown={onCaseSearchListPopupShowing}
        mdaeContentRender={() => (
          <div>
            <MdaePopupContent className="case-criteria-list-popup-content">
              <div className="from-to-date-container">
                <div className={"from-date-container"}>
                  <MdaeDateBox
                    id="dtService From"
                    tabIndex={1}
                    required
                    width={132}
                    mdaeDateBoxTitle="Service From"
                    value={
                      props.location ===
                      CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE
                        ? serviceFrom
                        : auditPropertiesData.serviceFromDate
                    }
                    onValueChanged={changeServiceFromDate}
                  ></MdaeDateBox>
                </div>
                <div className={"endDate"}>
                  <MdaeDateBox
                    id="dtServiceTo"
                    tabIndex={2}
                    width={132}
                    required
                    mdaeDateBoxTitle="Service To"
                    value={
                      props.location ==
                      CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE
                        ? serviceTo
                        : auditPropertiesData.serviceToDate
                    }
                    onValueChanged={changeServiceToDate}
                  ></MdaeDateBox>
                </div>
                {props.showClaimTypeSelector && (
                  <div style={{ marginLeft: 12, maxWidth: 220 }}>
                    <MdaeSelectBox
                      id="ddlCaseSearchClaimType"
                      mdaeDropDownBoxTitle="Claim Type"
                      placeholder="Select Claim Type"
                      items={[
                        {
                          text: "Professional",
                          value: CLAIM_TYPES.PROFESSIONAL,
                        },
                        { text: "Hospital", value: CLAIM_TYPES.HOSPITAL },
                      ]}
                      displayExpr="text"
                      valueExpr="value"
                      value={keyInformationCaseSearchData.claimTypeCd}
                      onValueChanged={onClaimTypeChanged}
                      required={true}
                    />
                  </div>
                )}
                {dosSearchType === DOS_SEARCH_TYPES.SINGLE_DOS && (
                  <div className="search-by-container">
                    <div className="search-by-options-container">
                      <div className="search-by-row">
                        <div className="search-by-label">Search By:</div>
                        <div className="search-by-radio-wrapper">
                          <MdaeRadioGroup
                            id={"radioGroup_" + selectedSearchBy}
                            valueExpr="searchByKey"
                            displayExpr="searchByExpr"
                            value={selectedSearchBy}
                            layout="vertical"
                            items={
                              keyInformationCaseSearchData.claimTypeCd === "I"
                                ? searchByListForHB
                                : searchByListForPB
                            }
                            onValueChanged={(e) => {
                              dispatch({
                                type: SET_SEARCH_BY,
                                data: {
                                  selectedSearchBy: e.value,
                                },
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <DataGrid
                ref={caseSearchListDataGridRef}
                {...restConfigurations}
                className={
                  datagridSelectionMode ===
                  CASE_SEARCH_DATAGRID_SELECTION_MODES.NONE
                    ? "case-criteria-datagrid-none-selection"
                    : "case-criteria-datagrid-multiple-selection"
                }
                dataSource={caseSearchCriteriaList}
                onRowCollapsed={onMasterRowCollapsedOrExpanded}
                onRowExpanded={onMasterRowCollapsedOrExpanded}
                onSaving={onCaseSearchCriteriaDatagridSaving}
                onRowInserted={onCaseSearchCriteriaDatagridRowInserted}
                allowColumnResizing={false}
              >
                <Editing
                  mode="cell"
                  allowUpdating={true}
                  allowAdding={true}
                  allowDeleting={false}
                  confirmDelete={false}
                />
                <Toolbar>
                  <Item
                    visible={
                      props.location !==
                      CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE
                    }
                  >
                    <MdaeAddButton
                      id={""}
                      style={{ marginRight: 10 }}
                      title={"Add New Row"}
                      onClick={() => {
                        getCaseSearchListDataGridInstance().addRow();
                      }}
                    ></MdaeAddButton>
                  </Item>
                  <Item location="after">
                    <Button
                      onClick={bulkDeleteSelectedRows}
                      elementAttr={{ class: "criteria-datagrid-delete-icon" }}
                      onContentReady={(e) => {
                        $(e.element)
                          .find(".dx-icon")
                          .addClass("application-section-primary-color");
                      }}
                      icon="trash"
                      stylingMode="text"
                      text=""
                      hint="Bulk Delete"
                      id={"btnBulkDeleteCaseSearchCriteria"}
                    />
                  </Item>
                  <Item name="exportButton" />
                  <Item location="before">
                    <i
                      style={{ fontSize: 20 }}
                      title={
                        keyInformationCaseSearchData.dosSearchType ===
                        DOS_SEARCH_TYPES.DOS_RANGE
                          ? `${
                              isClaimIdSearchAppplicble
                                ? CASE_SEARCH_WARNING_MESSAGES.HEADERS_INFORMATION_ICON_MASSAGE_NON_PRE_PAY_DOS_RANGE
                                : CASE_SEARCH_WARNING_MESSAGES.HEADERS_INFORMATION_ICON_MASSAGE_DOS_RANGE
                            }`
                          : `${
                              isClaimIdSearchAppplicble
                                ? keyInformationCaseSearchData.claimTypeCd ==
                                  "I"
                                  ? CASE_SEARCH_WARNING_MESSAGES.HEADERS_INFORMATION_ICON_MASSAGE_NON_PRE_PAY_SINGLE_DOS_HOSPITAL
                                  : CASE_SEARCH_WARNING_MESSAGES.HEADERS_INFORMATION_ICON_MASSAGE_NON_PRE_PAY_SINGLE_DOS_PROFESSIONAL
                                : keyInformationCaseSearchData.claimTypeCd ==
                                  "I"
                                ? CASE_SEARCH_WARNING_MESSAGES.HEADERS_INFORMATION_ICON_MASSAGE_SINGLE_DOS_HOSPITAL
                                : CASE_SEARCH_WARNING_MESSAGES.HEADERS_INFORMATION_ICON_MASSAGE_SINGLE_DOS_PROFESSIONAL
                            }`
                      }
                      className="img-circle fa fa-info-circle audit-info-circle application-section-primary-color"
                    ></i>
                  </Item>
                </Toolbar>
                <Selection
                  mode={datagridSelectionMode}
                  showCheckBoxesMode={"always"}
                />
                {caseFoundListDependantColumns}
                {caseSearchCriteraColumns}
                <MasterDetail
                  autoExpandAll={
                    props.location ===
                    CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE
                  }
                  enabled={
                    caseSearchCriteriaPopupMode ===
                    CASE_SEARCH_CRITERIA_POPUP_MODE.CASE_SEARCH
                  }
                  component={
                    props.location ===
                    CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE
                      ? MasterDetailComponentForCaseSearchPage
                      : MasterDetailComponentForAuditCaseSearch
                  }
                />
              </DataGrid>
            </MdaePopupContent>
          </div>
        )}
        mdaeFooterRenderComponent={caseSearchCriteriaFooterComponent}
      ></MdaePopup>
      {/*  below popup is responsible for Enhance Smart Scan  */}
      {isOcrUserFeedbackPopupVisible && <OcrUserFeedbackPopup />}
    </>
  );
};

export const validateCaseSearchRow = (rowData, claimType, dosSearchType, eaAuditType, templateType, selectedSearchBy = SEARCH_BY.DISCHARGE) => {
  const isDosSearchTypeInRange = dosSearchType === DOS_SEARCH_TYPES.DOS_RANGE;
  const {
    caseSearchIdentifiers,
    caseSearchCriteriaFiedMapperObject: ocrResultToCaseSearchTitlesMatching,
  } = getCaseSearchCriteriaMappings(claimType, eaAuditType, templateType, selectedSearchBy);
  let isClaimIdSearchAppplicble = true;
  if(eaAuditType)
    isClaimIdSearchAppplicble = checkIsClaimIdSearchAppplicble(eaAuditType);
  let patientIdentifiers = caseSearchIdentifiers.patientIdentifiers;
  let serviceIdentifiers = [];
  if (claimType?.toUpperCase() == CLAIM_TYPES.HOSPITAL) {
    serviceIdentifiers =
      caseSearchIdentifiers.serviceIdentifiers.hospitalClaimServiceIdentifiers;
  } else if (claimType?.toUpperCase() == CLAIM_TYPES.PROFESSIONAL) {
    serviceIdentifiers =
      caseSearchIdentifiers.serviceIdentifiers
        .professionalClaimServiceIdentifiers;
  }
  patientIdentifiers = patientIdentifiers.map((x) => x.toLowerCase());
  serviceIdentifiers = serviceIdentifiers.map((x) => x.toLowerCase());

  let serviceIdentifierWeight = 0;
  let patientIdentifierWeight = 0;
  let totalIdentifierCount = 0;

  for (const [identifierKey, value] of Object.entries(rowData)) {
    let isServiceIdentifierFound = false;
    let isPatientIdentifierFound = false;
    let isAnyidentifierFound = false;
    let isValidValue = Boolean(value);
    if (typeof value === "string") isValidValue = Boolean(value.trim());
    if (isValidValue) {
      if (patientIdentifiers.includes(identifierKey.toLowerCase())) {
        isPatientIdentifierFound = true;
        isAnyidentifierFound = true;
        totalIdentifierCount++;
      }
      if (serviceIdentifiers.includes(identifierKey.toLowerCase())) {
        isServiceIdentifierFound = true;
        isAnyidentifierFound = true;
        totalIdentifierCount++;
      }
      if (isAnyidentifierFound) {
        const identifierObject = Object.keys(
          ocrResultToCaseSearchTitlesMatching
        )
          .filter(
            (x) =>
              ocrResultToCaseSearchTitlesMatching[x].keyExpr?.toLowerCase() === identifierKey?.toLowerCase()
          )
          .map((x) => ocrResultToCaseSearchTitlesMatching[x])[0];

        if (isServiceIdentifierFound)
          serviceIdentifierWeight += identifierObject.caseSearchWeight;

        if (isPatientIdentifierFound)
          patientIdentifierWeight += identifierObject.caseSearchWeight;

        //payerRemitNo super identifier is only applicable for POST_PAY and DENIAL which is
        //checked by isClaimIdSearchAppplicble
        //super identifier is sufficient to identify a claim and hence surpassess all minimum weight criteria
        if (identifierObject.isSuperIdentifier) {
          const isPayerRemitNoMatch =
          identifierKey ===
            ocrResultToCaseSearchTitlesMatching.payer_remit_no.keyExpr;
          if (isPayerRemitNoMatch && isClaimIdSearchAppplicble) {
            serviceIdentifierWeight += 2;
            patientIdentifierWeight += 2;
            totalIdentifierCount += 2;
          } else if (!isPayerRemitNoMatch) {
            serviceIdentifierWeight += 2;
            patientIdentifierWeight += 2;
            totalIdentifierCount += 2;
          }
        }
      }
    }
  }
  let validRow = false;
   if (isDosSearchTypeInRange) {
    //In case of DOS range search below condition checks that
    //the weight of patient identifier should be at least 1.6
    validRow = patientIdentifierWeight >= 1.6 && totalIdentifierCount >= 1.6;
  } else {
    //in case of single DOS search
    //below condition checks that at least one service identifier and
    //one patient identifier is present
    //and total number of identifier should be at least 3
    validRow =
      serviceIdentifierWeight >= 1 &&
      patientIdentifierWeight >= 1 &&
      totalIdentifierCount >= 3;
  }

  return {
    isValidRow: validRow,
    isEmptyRow: totalIdentifierCount === 0,
  };
};

export const getTemplateType = (claimTypeCode, caseSearchDataColumns: any) => {
  const { caseSearchCriteriaFiedMapperObject } = getCaseSearchCriteriaMappings(
    claimTypeCode
  );
  if (
    caseSearchDataColumns.includes(
      caseSearchCriteriaFiedMapperObject.retained_amount.displayAlias
    )
  ) {
    return TEMPLATE_TYPES.MDM;
  }
  return null;
};

const getCaseSearchCriteraListDataGridOptions = (claimTypeCode: string, exportToExcelFileName: string, templateType: string,dosSearchType:string) => {
  const caseSearchCriteriaColumns =
    claimTypeCode?.toUpperCase() === CLAIM_TYPES.HOSPITAL
      ? getHospitalColumns(claimTypeCode, templateType,dosSearchType)
      : getProfessionalColumns(claimTypeCode, templateType,dosSearchType);

  const caseSearchListDataGridOptions: IMdaeDataGridProps = {
    id: "grdCaseSearchCriteriaList",
    allowColumnResizing: true,
    wordWrapEnabled: true,
    repaintChangesOnly: true,
    keyExpr: caseSearchCriteriaDatagridKeyExpr,
    allowColumnReordering: true,
    showBorders: true,
    showColumnLines: false,
    showRowLines: true,
    rowAlternationEnabled: true,
    export: {
      fileName: exportToExcelFileName,
      enabled: true,
    },
    filterRow: { visible: true },
    headerFilter: { visible: true },
    scrolling: {
      columnRenderingMode: "virtual",
    },
    columns: [...caseSearchCriteriaColumns],
    pager: {
      displayMode: "full",
      showPageSizeSelector: true,
      allowedPageSizes: [10, 20, 30],
      showInfo: true,
    },
  };
  return caseSearchListDataGridOptions;
};

const getProfessionalColumns = (claimType, templateType,dosSearchType): IMdaeDataGridColumnProps[] => {
  const {
    caseSearchCriteriaFiedMapperObject: ocrResultToCaseSearchTitlesMatching,
  } = getCaseSearchCriteriaMappings(claimType, null, templateType);
  var columns = [
    {
      dataField: ocrResultToCaseSearchTitlesMatching.subscriber_id.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.subscriber_id.displayAlias,
      dataType: "string",
      width: 120,
      allowEditing: true,
    },
    {
      dataField:ocrResultToCaseSearchTitlesMatching.patient_acct_no_orig.caseFoundKeyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.patient_acct_no_orig.displayAlias,
      dataType: "string",
      width: 120,
      allowEditing: true,
    },
    {
      dataField:ocrResultToCaseSearchTitlesMatching.payer_remit_no.caseFoundKeyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.payer_remit_no.displayAlias,
      dataType: "string",
      width: 120,
      allowEditing: true,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.patient_last_name.keyExpr,
      caption:
        ocrResultToCaseSearchTitlesMatching.patient_last_name.displayAlias,
      dataType: "string",
      width: 120,
      allowEditing: true,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.patient_first_name.keyExpr,
      caption:
        ocrResultToCaseSearchTitlesMatching.patient_first_name.displayAlias,
      dataType: "string",
      width: 120,
      allowEditing: true,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.dob.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.dob.displayAlias,
      format: "MM/dd/yyyy",
      dataType: "date",
      width: 95,
      allowEditing: true,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.mrn.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.mrn.displayAlias,
      dataType: "string",
      width: 110,
      allowEditing: true,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.from_date.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.from_date.displayAlias,
      format: "MM/dd/yyyy",
      dataType: "date",
      width: 95,
      allowEditing: dosSearchType ===DOS_SEARCH_TYPES.SINGLE_DOS ,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.dos.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.dos.displayAlias,
      format: "MM/dd/yyyy",
      dataType: "date",
      width: 95,
      allowEditing: dosSearchType ===DOS_SEARCH_TYPES.SINGLE_DOS ,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.claim_id.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.claim_id.displayAlias,
      dataType: "string",
      minWidth: 135,
      allowEditing: dosSearchType ===DOS_SEARCH_TYPES.SINGLE_DOS ,
      headerCellRender: () =>
        getHeaderColumnWithNote(
          ocrResultToCaseSearchTitlesMatching.claim_id.displayAlias,
          CASE_SEARCH_WARNING_MESSAGES.NON_CASE_SEARCH_PAYER_CASE_ID
        ),
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.pos.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.pos.displayAlias,
      width: 65,
      allowEditing: false,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.cpt_hcpcs_code.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.cpt_hcpcs_code.displayAlias,
      minWidth: 130,
      allowEditing: false,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.modifier.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.modifier.displayAlias,
      width: 85,
      allowEditing: false,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.npi.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.npi.displayAlias,
      dataType: "string",
      width: 130,
      allowEditing: false,
    },
  ];
  if(templateType === TEMPLATE_TYPES.MDM){
    var atRiskColumn = [{
      dataField: ocrResultToCaseSearchTitlesMatching.retained_amount.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.retained_amount.displayAlias,
      dataType: "string",
      width: 130,
      allowEditing: false,
    },]
    columns=[...columns,...atRiskColumn];
  }
  return columns;
};

const getHospitalColumns = (claimType, templateType,dosSearchType ): IMdaeDataGridColumnProps[] => {
  const {
    caseSearchCriteriaFiedMapperObject: ocrResultToCaseSearchTitlesMatching,
  } = getCaseSearchCriteriaMappings(claimType, null, templateType);
  var columns = [
    {
      dataField: ocrResultToCaseSearchTitlesMatching.subscriber_id.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.subscriber_id.displayAlias,
      dataType: "string",
      width: 120,
      allowEditing: true,
    },
    {
      dataField:ocrResultToCaseSearchTitlesMatching.patient_acct_no_orig.caseFoundKeyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.patient_acct_no_orig.displayAlias,
      dataType: "string",
      width: 120,
      allowEditing: true,
    },
    {
      dataField:ocrResultToCaseSearchTitlesMatching.payer_remit_no.caseFoundKeyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.payer_remit_no.displayAlias,
      dataType: "string",
      width: 120,
      allowEditing: true,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.patient_last_name.keyExpr,
      caption:
        ocrResultToCaseSearchTitlesMatching.patient_last_name.displayAlias,
      dataType: "string",
      width: 120,
      allowEditing: true,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.patient_first_name.keyExpr,
      caption:
        ocrResultToCaseSearchTitlesMatching.patient_first_name.displayAlias,
      dataType: "string",
      width: 120,
      allowEditing: true,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.dob.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.dob.displayAlias,
      format: "MM/dd/yyyy",
      dataType: "date",
      width: 95,
      allowEditing: true,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.mrn.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.mrn.displayAlias,
      dataType: "string",
      width: 110,
      allowEditing: true,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.admit_date.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.admit_date.displayAlias,
      format: "MM/dd/yyyy",
      dataType: "date",
      width: 95,
      allowEditing: dosSearchType ===DOS_SEARCH_TYPES.SINGLE_DOS,
      calculateCellValue: (row) => { const v = row.inpatientAdmitDate || row.caseServiceFromDate; return v ? new Date(v) : null; },
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.discharge_date.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.discharge_date.displayAlias,
      format: "MM/dd/yyyy",
      dataType: "date",
      width: 95,
      allowEditing: dosSearchType ===DOS_SEARCH_TYPES.SINGLE_DOS,
      calculateCellValue: (row) => { const v = row.inpatientDischargeDate || row.caseServiceThroughDate; return v ? new Date(v) : null; },
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.claim_id.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.claim_id.displayAlias,
      headerCellRender: () =>
        getHeaderColumnWithNote(
          ocrResultToCaseSearchTitlesMatching.claim_id.displayAlias,
          CASE_SEARCH_WARNING_MESSAGES.NON_CASE_SEARCH_PAYER_CASE_ID
        ),
      dataType: "string",
      minWidth: 135,
      allowEditing: dosSearchType ===DOS_SEARCH_TYPES.SINGLE_DOS ,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.drg.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.drg.displayAlias,
      width: 65,
      allowEditing: false,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.primary_diagnosis.keyExpr,
      caption:
        ocrResultToCaseSearchTitlesMatching.primary_diagnosis.displayAlias,
      minWidth: 120,
      allowEditing: false,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.cpt_hcpcs_code.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.cpt_hcpcs_code.displayAlias,
      minWidth: 130,
      allowEditing: false,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.modifier.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.modifier.displayAlias,
      width: 85,
      allowEditing: false,
    },
    {
      dataField: ocrResultToCaseSearchTitlesMatching.npi.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.npi.displayAlias,
      dataType: "string",
      width: 130,
      allowEditing: false,
    }
  ];
  if(templateType === TEMPLATE_TYPES.MDM){
    var atRiskColumn = [{
            dataField: ocrResultToCaseSearchTitlesMatching.retained_amount.keyExpr,
            caption: ocrResultToCaseSearchTitlesMatching.retained_amount.displayAlias,
            dataType: "string",
            width: 130,
            allowEditing: false,
          }];
    columns=[...columns,...atRiskColumn];
  }
  return columns;
};

const getCaseSearchCriteriaStartColumns = (
  keyInformationCaseSearchData,
  caseFoundList: any[],
  caseSearchClickedInd,
  eaAuditType: string,
  templateType,
  selectedSearchBy = SEARCH_BY.DISCHARGE
): IMdaeDataGridColumnProps[] => {
  const claimType = keyInformationCaseSearchData.claimTypeCd;
  const dosSearchType = keyInformationCaseSearchData.dosSearchType;
  let isClaimIdSearchAppplicble = true;
  if(eaAuditType)
    isClaimIdSearchAppplicble = checkIsClaimIdSearchAppplicble(eaAuditType);
  return [
    {
      name: validationColumnName,
      allowSorting: false,
      allowFiltering: false,
      fixed: true,
      allowEditing: false,
      allowExporting: false,
      allowResizing: false,
      allowReordering: false,
      alignment: "center",
      cssClass: "validation-column-max-width",
      cellRender: (e) => {
        const { isValidRow, isEmptyRow } = validateCaseSearchRow(
          e.data,
          claimType,
          dosSearchType,
          eaAuditType,
          templateType,
          selectedSearchBy
        );
        const isRowCollapsedAndCasesFound =
          !e.component.isRowExpanded(e.key) &&
          caseFoundList.some(
            (x) => e.key === x[caseSearchCriteriaDatagridKeyExpr]
          );
        const isRowNonEmptyAndInvalid = !isEmptyRow && !isValidRow;
        const iswarningIconVisible =
          isRowNonEmptyAndInvalid || isRowCollapsedAndCasesFound;
        if (iswarningIconVisible) {
          let warningIconTitle = "";
          if (isRowCollapsedAndCasesFound)
            warningIconTitle += CASE_SEARCH_WARNING_MESSAGES.UNSELECTED_CASES;

          if (isRowNonEmptyAndInvalid) {
            const finalMessage =
              dosSearchType === DOS_SEARCH_TYPES.DOS_RANGE
                ? (isClaimIdSearchAppplicble
                    ?  CASE_SEARCH_WARNING_MESSAGES.ROW_INFORMATION_ICON_MASSAGE_NON_PRE_PAY_DOS_RANGE
                    :  CASE_SEARCH_WARNING_MESSAGES.ROW_INFORMATION_ICON_MASSAGE_DOS_RANGE)
                : (isClaimIdSearchAppplicble
                    ? (keyInformationCaseSearchData.claimTypeCd=='I'
                        ? CASE_SEARCH_WARNING_MESSAGES.ROW_INFORMATION_ICON_MASSAGE_NON_PRE_PAY_SINGLE_DOS_HOSPITAL
                        : CASE_SEARCH_WARNING_MESSAGES.ROW_INFORMATION_ICON_MASSAGE_NON_PRE_PAY_SINGLE_DOS_PROFESSIONAL)
                    : (keyInformationCaseSearchData.claimTypeCd=='I'
                        ? CASE_SEARCH_WARNING_MESSAGES.ROW_INFORMATION_ICON_MASSAGE_SINGLE_DOS_HOSPITAL
                        : CASE_SEARCH_WARNING_MESSAGES.ROW_INFORMATION_ICON_MASSAGE_SINGLE_DOS_PROFESSIONAL));

            warningIconTitle += `\n${finalMessage}`;
          }

          return (
            <div style={{ marginLeft: 15 }}>
              <i
                className="dx-icon warning-red"
                title={warningIconTitle}
                style={{ height: 18 }}
              ></i>
            </div>
          );
        } else return <></>;
      },
    },
    {
      caption: "",
      cssClass: "linked-audit-column-max-width",
    },
    {
      dataField: createdOn,
      name: createdOnColumn,
      caption: "",
      allowFiltering: false,
      visible: false,
      showInColumnChooser: false,
      calculateSortValue: (data) => {
        if (data.createdOn) return new Date(data.createdOn).getTime();
        else return -1;
      },
      sortOrder: "desc",
    },
    {
      dataField: sortOrder,
      name: sortOrderColumn,
      caption: "",
      allowFiltering: false,
      visible: false,
      showInColumnChooser: false,
      sortOrder: "asc",
    },
    {
      name: caseCountColumn,
      caption: "Case Count",
      width: 80,
      allowSorting: false,
      allowFiltering: false,
      allowEditing: false,
      allowExporting: false,
      allowResizing: false,
      allowReordering: false,
      alignment: "center",
      visible: caseSearchClickedInd,
      dataType: Number,
      cellRender: (e) => {
        if (caseFoundList != null && caseFoundList.length > 0) {
          return (
            caseFoundList.filter(
              (x) => e.key === x[caseSearchCriteriaDatagridKeyExpr]
            )?.length + ""
          );
        } else return "0";
      },
    },
  ];
};

const MasterDetailComponentForCaseSearchPage = (props) => {
  return (
    <CaseSearchMasterDetailComponent
      {...props}
      location={CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE}
    />
  );
};
const MasterDetailComponentForAuditCaseSearch = (props) => {
  return (
    <CaseSearchMasterDetailComponent
      {...props}
      location={CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.AUDIT}
    />
  );
};
interface ICaseSearchMasterDetailComponent {
  data: any;
  location: string;
}
const CaseSearchMasterDetailComponent: React.FC<ICaseSearchMasterDetailComponent> = (
  props
) => {
  const dispatch = useDispatch();
  const caseFoundList: any[] = useSelector(
    (state) => state["caseSearchReducer"].caseFoundList,
    isEqual
  );
  const caseFoundListidentifier = useSelector(
    (state) =>
      state["caseSearchReducer"].caseFoundList?.reduce(
        (allCaseDetails, current) => (allCaseDetails += current?.caseDetailId),
        "" //this is initial value
      ),
    isEqual
  );
  const selectedCaseDetailIdsToAddToAudit: number[] = useSelector(
    (state) => state["caseSearchReducer"].selectedCaseDetailIdsToAddToAudit,
    isEqual
  );
  const claimTypeCd = useSelector(
    (state) =>
      state["caseSearchReducer"].keyInformationCaseSearchData.claimTypeCd,
    isEqual
  );
  const templateType = useSelector(
    (state) => state["caseSearchReducer"].keyInformationCaseSearchData.templateType
  );
  const dosSearchType = useSelector(
    (state) => state["caseSearchReducer"].keyInformationCaseSearchData.dosSearchType,
    isEqual
  );
  const caseFoundListDataGridOptions = useMemo(
    () =>
      getCaseFoundListDataGridOptions(dispatch, claimTypeCd, props.data.key, templateType, props.location,dosSearchType),
    [caseFoundList]
  );

  const onCaseFoundMasterDatagridSelectionChanged = useCallback((e) => {
    if (e.currentSelectedRowKeys?.length > 0)
      dispatch({
        type: ADD_SELECTED_IDS_TO_ADD_TO_AUDIT_LIST,
        data: e.currentSelectedRowKeys,
      });

    if (e.currentDeselectedRowKeys?.length > 0)
      dispatch({
        type: REMOVE_SELECTED_IDS_TO_ADD_TO_AUDIT_LIST,
        data: e.currentDeselectedRowKeys,
      });
  }, []);

  const cellRender = useCallback((e) => {
    return (
      <span
        title={e.text}
        className={
          e.data[e.column.dataField + "Found"] ? "bold-text" : "normal-text"
        }
      >
        {" "}
        {e.text}
      </span>
    );
  }, []);
  const {
    mdaeColumns: columnConfigurations,
    ...restConfigurations
  } = caseFoundListDataGridOptions;
  const columns = useMemo(
    () =>
      columnConfigurations.map(
        (columnsProps: IMdaeDataGridColumnProps, index) => {
          return (
            <Column
              cellRender={cellRender}
              {...columnsProps}
              key={`caseFoundMasterGridColumn${index}${columnsProps.dataField ||
                columnsProps.name}`}
            />
          );
        }
      ),
    []
  );

  const caseFoundListDataSource = useMemo(
    () =>
      new DataSource({
        store: new ArrayStore({
          data: caseFoundList,
          key: "caseDetailId",
        }),
        filter: [caseSearchCriteriaDatagridKeyExpr, "=", props.data.key],
        sort: [
          { selector: totalIdentifierMatchedCountColumnName, desc: true },
          { selector: totalIdentifierMatchedWeightColumnName, desc: true }
      ],
      }),
    [caseFoundListidentifier]
  );

  return caseFoundList.some(
    (x) => x[caseSearchCriteriaDatagridKeyExpr] === props.data.key
  ) ? (
    <DataGrid
      {...restConfigurations}
      onSelectionChanged={onCaseFoundMasterDatagridSelectionChanged}
      dataSource={caseFoundListDataSource}
      selectedRowKeys={selectedCaseDetailIdsToAddToAudit}
      sorting={{}}
      className="case-search-criteria-master-grid"
    >
      {columns}
      <Selection
        mode={
          props.location ===
          CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE
            ? "single"
            : "multiple"
        }
        showCheckBoxesMode="always"
        allowSelectAll={false}
      />
      <Scrolling showScrollbar={"never"} />
    </DataGrid>
  ) : (
    <div style={{ padding: "10px 20px" }}>No Cases Found</div>
  );
};

export const viewCaseDetails = (dispatch, cellData) => {
  let data = {
    caseId: cellData.caseId,
    caseDetailId: cellData.caseDetailId,
    caseBranchNo: cellData.caseBranchNo,
    billTypeFacility: cellData.billTypeFacility,
    totalCharges: cellData.totalCharges,
    sequence: cellData.sequence,
    claimType:
      cellData.claimTypeCode?.toUpperCase() == CLAIM_TYPES.HOSPITAL
        ? "HOSPITAL"
        : "PROFESSIONAL",
    visible: true,
  };
  toggleCaseDetailPopup(
    dispatch,
    true,
    "Audit Case Details (View Only)",
    data,
    3
  );
};
export const linkedAuditColumnCellRender = (dispatch, cellData) => {
  return cellData.value ? (
    <div
      title="This case appears in another Payer Audit. Click to see other linked audits."
      className="case-list-preview-action"
    >
      <i
        className="fa fa-exclamation-triangle"
        style={{ color: "orange" }}
        onClick={(e) => {
          viewCaseDetails(dispatch, cellData.data);
        }}
      ></i>
    </div>
  ) : (
    <></>
  );
};
const getCaseFoundListDataGridOptions = (
  dispatch,
  claimType,
  uniqueId,
  templateType,
  location,
  dosSearchType
) => {
  const {
    caseSearchCriteriaFiedMapperObject: ocrResultToCaseSearchTitlesMatching,
  } = getCaseSearchCriteriaMappings(claimType);
  let caseFoundListColumns = [];
  let restColumns = [];
  const startColumns = [
    {
      visible: false,
      showInColumnChooser: false,
      dataField: totalIdentifierMatchedWeightColumnName,
    },
    {
      visible: false,
      showInColumnChooser: false,
      dataField: totalIdentifierMatchedCountColumnName,
    },
    ...(location === CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE
      ? [
          {
            dataField: "chcek",
            allowExporting: false,
            caption: "",
            alignment: "center",
            width: 40,
            allowFiltering: false,
            allowSorting: false,
            allowHeaderFiltering: false,
            allowHiding: false,
            allowReordering: false,
            fixed: true,
            fixedPosition: "left",
            cellRender: (params) => {
              return <RadioSelectionCellComponent data={params} />;
            },
          },
        ]
      : []),
    {
      name: "isLinkedAuditPresent",
      dataField: "isLinkedAuditPresent",
      caption: "",
      alignment: "center",
      allowResizing: false,
      allowExporting: false,
      cellRender: (celData) => linkedAuditColumnCellRender(dispatch, celData),
      cssClass: "command-column-max-width",
    },
    {
      name: "actionId",
      dataField: "caseId",
      caption: "",
      alignment: "center",
      allowResizing: false,
      allowExporting: false,
      cellRender: (cellData) => {
        return (
          <div className={"case-list-preview-action"}>
            <i
              style={{ height: "14px" }}
              className={"preview-action-icon"}
              onClick={(e) => {
                viewCaseDetails(dispatch, cellData.data);
              }}
            ></i>
          </div>
        );
      },
      cssClass: "command-column-max-width",
    },
    {
      dataField:
        ocrResultToCaseSearchTitlesMatching.case_count.caseFoundKeyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.case_count.displayAlias,
      dataType: "number",
      width: 80,
    },
  ];
    const customClaimColumns =
      claimType?.toUpperCase() === CLAIM_TYPES.HOSPITAL
        ? [  {
              dataField:
                ocrResultToCaseSearchTitlesMatching.admit_date
                  .caseFoundKeyExpr,
              caption:
                ocrResultToCaseSearchTitlesMatching.admit_date.displayAlias,
              format: "MM/dd/yyyy",
              dataType: "date",
              width: 95,
              allowEditing: dosSearchType ===DOS_SEARCH_TYPES.SINGLE_DOS ,

            },
            {
              dataField:
                ocrResultToCaseSearchTitlesMatching.discharge_date
                  .caseFoundKeyExpr,
              caption:
                ocrResultToCaseSearchTitlesMatching.discharge_date.displayAlias,
              format: "MM/dd/yyyy",
              dataType: "date",
              width: 95,
              allowEditing:dosSearchType ===DOS_SEARCH_TYPES.SINGLE_DOS ,
            },
            {
              dataField:
                ocrResultToCaseSearchTitlesMatching.claim_id.caseFoundKeyExpr,
              caption: ocrResultToCaseSearchTitlesMatching.claim_id.displayAlias,
              dataType: "string",
              minWidth: 135,
              allowEditing: dosSearchType ===DOS_SEARCH_TYPES.SINGLE_DOS ,
            },
            {
              dataField:
                ocrResultToCaseSearchTitlesMatching.drg.caseFoundKeyExpr,
              caption: ocrResultToCaseSearchTitlesMatching.drg.displayAlias,
              width: 65,
              allowEditing: false,
            },
            {
              dataField:
                ocrResultToCaseSearchTitlesMatching.primary_diagnosis
                  .caseFoundKeyExpr,
              caption:
                ocrResultToCaseSearchTitlesMatching.primary_diagnosis
                  .displayAlias,
              minWidth: 120,
              allowEditing: false,
            },
          ]
        : [
            {
              dataField:
                ocrResultToCaseSearchTitlesMatching.from_date.caseFoundKeyExpr,
              caption: ocrResultToCaseSearchTitlesMatching.from_date.displayAlias,
              format: "MM/dd/yyyy",
              dataType: "date",
              width: 95,
              allowEditing: dosSearchType ===DOS_SEARCH_TYPES.SINGLE_DOS ,
            },
            {
              dataField:
                ocrResultToCaseSearchTitlesMatching.dos.caseFoundKeyExpr,
              caption: ocrResultToCaseSearchTitlesMatching.dos.displayAlias,
              format: "MM/dd/yyyy",
              dataType: "date",
              width: 95,
              allowEditing: dosSearchType ===DOS_SEARCH_TYPES.SINGLE_DOS ,
            },
            {
              dataField:
                ocrResultToCaseSearchTitlesMatching.claim_id.caseFoundKeyExpr,
              caption: ocrResultToCaseSearchTitlesMatching.claim_id.displayAlias,
              dataType: "string",
              minWidth: 135,
              allowEditing: dosSearchType ===DOS_SEARCH_TYPES.SINGLE_DOS ,
            },
            {
              caption: ocrResultToCaseSearchTitlesMatching.pos.displayAlias,
              dataField:
                ocrResultToCaseSearchTitlesMatching.pos.caseFoundKeyExpr,
              width: 65,
              allowEditing: false,
            },
          ];

    restColumns = [

      {
        dataField:
          ocrResultToCaseSearchTitlesMatching.subscriber_id.caseFoundKeyExpr,
        caption: ocrResultToCaseSearchTitlesMatching.subscriber_id.displayAlias,
        dataType: "string",
        width: 120,
        allowEditing: true,
      },
      {
        dataField:
          ocrResultToCaseSearchTitlesMatching.patient_acct_no_orig
            .caseFoundKeyExpr,
        caption:
          ocrResultToCaseSearchTitlesMatching.patient_acct_no_orig.displayAlias,
        dataType: "string",
        width: 120,
        allowEditing: true,
      },
      {
        dataField:
          ocrResultToCaseSearchTitlesMatching.payer_remit_no.caseFoundKeyExpr,
        caption:
          ocrResultToCaseSearchTitlesMatching.payer_remit_no.displayAlias,
        dataType: "string",
        width: 120,
        allowEditing: true,
      },
      {
        dataField:
          ocrResultToCaseSearchTitlesMatching.patient_last_name
            .caseFoundKeyExpr,
        caption:
          ocrResultToCaseSearchTitlesMatching.patient_last_name.displayAlias,
        dataType: "string",
        width: 120,
        allowEditing: true,
      },
      {
        dataField:
          ocrResultToCaseSearchTitlesMatching.patient_first_name
            .caseFoundKeyExpr,
        caption:
          ocrResultToCaseSearchTitlesMatching.patient_first_name.displayAlias,
        dataType: "string",
        width: 120,
        allowEditing: true,
      },
      {
        dataField: ocrResultToCaseSearchTitlesMatching.dob.caseFoundKeyExpr,
        caption: ocrResultToCaseSearchTitlesMatching.dob.displayAlias,
        dataType: "date",
        format: "MM/dd/yyyy",
        width: 95,
        allowEditing: true,
      },
      {
        dataField: ocrResultToCaseSearchTitlesMatching.mrn.caseFoundKeyExpr,
        caption: ocrResultToCaseSearchTitlesMatching.mrn.displayAlias,
        width: 110,
        allowEditing: true,
      },
      ...customClaimColumns,

      {
        dataField:
          ocrResultToCaseSearchTitlesMatching.cpt_hcpcs_code.caseFoundKeyExpr,
        minWidth: 130,
        allowEditing: false,
        caption:
          ocrResultToCaseSearchTitlesMatching.cpt_hcpcs_code.displayAlias,
      },
      {
        dataField:
          ocrResultToCaseSearchTitlesMatching.modifier.caseFoundKeyExpr,
        caption: ocrResultToCaseSearchTitlesMatching.modifier.displayAlias,
        width: 85,
        allowEditing: false,
        cellRender: (e) => {
          const modifiers: string = e.data.modifiers;
          const commaSeperatedModifiers = modifiers
            .split(" ")
            .filter((x) => x?.length > 0)
            .map((x) => x.trim())
            .join(", ");
          return (
            <span title={commaSeperatedModifiers}>
              {commaSeperatedModifiers}
            </span>
          );
        },
      },
      {
        dataField: ocrResultToCaseSearchTitlesMatching.npi.caseFoundKeyExpr,
        caption: ocrResultToCaseSearchTitlesMatching.npi.displayAlias,
        width: 130,
        allowEditing: false,
      },

    ];

  let atRiskColumn=[];
  if(templateType === TEMPLATE_TYPES.MDM){
      atRiskColumn = [{
      dataField: ocrResultToCaseSearchTitlesMatching.retained_amount.keyExpr,
      caption: ocrResultToCaseSearchTitlesMatching.retained_amount.displayAlias,
      dataType: "string",
      width: 130
    },]}

  caseFoundListColumns = [...startColumns, ...restColumns,...atRiskColumn];
  const caseFoundListDataGridOptions: IMdaeDataGridProps = {
    id: "grdCaseSearchFoundList" + uniqueId,
    allowColumnResizing: true,
    showColumnHeaders: false,
    mdaeColumns: caseFoundListColumns,
  };
  return caseFoundListDataGridOptions;
};

export default CaseSearchCriteriaListPopup;
